import React from "react";
import styles from "./WizardPageController.module.css";
import {
  WizardPageControllerProps,
  WizardSharedData,
} from "./WizardPageController.utils";

function WizardPageController<CustomSharedData extends WizardSharedData>({
  config,
  componentMap,
  sharedData,
  setSharedData,
  activeStep,
  onFormLoaded
}: WizardPageControllerProps<CustomSharedData>) {
  // Generate components outside useEffect in useMemo to avoide infinite rerender
  const components = React.useMemo(() => {
    const sorted = config
      .filter((page) => page.show)
      .sort((a, b) => a.order - b.order);

    return sorted.map((page, index) => {
      const Component = componentMap[page.key];
      if (!Component) {
        console.warn(`Component not found for key: ${page.key}`);
        return null;
      }

      return (
        <Component
          key={page.key}
          sharedData={sharedData}
          setSharedData={setSharedData}
          onValidationChange={(isValid) => {
            setSharedData((prev) => ({
              ...prev,
              validations: {
                ...prev.validations,
                [index]: isValid,
              },
            }));
          }}
          onFormLoaded={onFormLoaded}
          {...(page.props || {})}
        />
      );
    });
  }, [config, componentMap, sharedData, setSharedData]);

  return (
    <div>
      {/* Render Active Page */}
      <div>{components[activeStep]}</div>
    </div>
  );
}

export default WizardPageController;
